import { render, staticRenderFns } from "./DisplayProductPriceNew.vue?vue&type=template&id=5272fe70"
import script from "./DisplayProductPriceNew.vue?vue&type=script&lang=js"
export * from "./DisplayProductPriceNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports